import { RegistrarseComponent } from './../registrarse/registrarse.component';


import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { Location } from '@angular/common';
import { OlvidoComponent } from '../olvido/olvido.component';
import { AuthService } from '../service/seguridad/auth.service';
import { Usuario } from '../service/usuario.model';
import { MensajeComponent } from '../mensaje/mensaje.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { UsuariosDataService } from '../service/data/usuarios-data.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: false
})
export class LoginComponent implements OnInit {


 
  mostrarPassword: boolean;
  usuario:Usuario
  errorMessage="Invalid credentials";
  invalidLogin =false;
  cargando: boolean = false;
  correoUsuario: string;
  mostrarVerificacion: boolean = false;
  codigoVerificacion: string;
  digito1: string = '';
  digito2: string = '';
  digito3: string = '';
  digito4: string = '';
  tiempoRestante: number = 60; // 60 segundos = 1 minuto
  puedeReenviar: boolean = false;
  intervaloContador: any;
  tokenId: string;
  correoPass: boolean;

  
  @ViewChild('input1') input1!: ElementRef;
  @ViewChild('input2') input2!: ElementRef;
  @ViewChild('input3') input3!: ElementRef;
  @ViewChild('input4') input4!: ElementRef;

  constructor( 
    //public autenticacion: HardcodedAutheticationService,
    public dialog: MatDialog,
    private location: Location,
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private usuariosService: UsuariosDataService) { 

  }

  ngOnInit(): void {
   this.usuario = new Usuario();
   this.mostrarPassword = false;
   this.correoPass = true;
   
   // La lógica de OAuth tokens ahora se maneja globalmente en app.component.ts
   // Solo mantener lógica específica del componente login si es necesario


  }

  togglePassword(){
    this.mostrarPassword = !this.mostrarPassword;
  }


  handleLogin2(){
    if (this.usuario.correo == null) {
      this.openMensaje('Correo vacío')
    }

    this.auth.logout;

    this.usuario.correo = this.usuario.correo.trim();

    this.auth.crearToken(this.usuario.correo).subscribe({
      next: response => {
        if(response.userExists){
          // Abrir ventana con cuatro espacios
          this.correoUsuario = this.usuario.correo;
          this.mostrarVerificacion = true;
          this.iniciarContador();
        } else {
          this.openMensaje('Se ha enviado un correo a ' + this.usuario.correo + ' para que puedas registrarte!');
        }
      },
      error: error => {
        if(error.status == 500) {
          this.openMensaje
        }
        this.usuario = new Usuario();
        this.invalidLogin = true;
      }
    })
  }

  verificarCodigo() {
    const codigo = this.obtenerCodigoCompleto();
    this.auth.newLogin(this.usuario.correo, codigo).subscribe({
      next: response => {
        this.auth.guardarUsuario(response.access_token);
        this.auth.guardarToken(response.access_token);
        
        let usuario = this.auth.usuario;
      },
      error: error=>{
        if(error.status == 401){
          this.openMensaje(error.error.error)
        }
        this.limpiarCodigo();
        this.invalidLogin =true;
      }
    })
  }

  convertirMayusculas(event: any, digitoName: string) {
    const valor = event.target.value.toUpperCase();
    this[digitoName] = valor;
    event.target.value = valor;
  }

  reenviarCodigo() {
    this.auth.reenviarToken(this.usuario.correo).subscribe({
      next: response => {
        if(response.userExists) {
          this.openMensaje('Mensaje reenviado a ' + this.usuario.correo);
          this.limpiarCodigo();
          this.iniciarContador();
        } else {
          alert(response.message)
        }
      }
    })
  }

  cerrarVerificacion() {
    this.mostrarVerificacion = false;
    this.codigoVerificacion = '';
  }

  moverSiguiente(event: any, siguienteInput: number) {
    const input = event.target;
    
    // Si se ingresó un valor, mover al siguiente
    if (input.value.length === 1) {
      const nextInput = document.querySelector(`input[name="digito${siguienteInput}"]`) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
    
    // Si se presiona backspace y el input está vacío, volver al anterior
    if (event.key === 'Backspace' && input.value === '') {
      const prevInput = document.querySelector(`input[name="digito${siguienteInput - 2}"]`) as HTMLInputElement;
      if (prevInput) {
        prevInput.focus();
      }
    }
  }

  // Función para obtener el código completo
  obtenerCodigoCompleto(): string {
    return this.digito1 + this.digito2 + this.digito3 + this.digito4;
  }

  limpiarCodigo() {
    this.digito1 = '';
    this.digito2 = '';
    this.digito3 = '';
    this.digito4 = '';
    
    // Enfocar el primer input
    const firstInput = document.querySelector('input[name="digito1"]') as HTMLInputElement;
    if (firstInput) {
      firstInput.focus();
    }
  }

  iniciarContador() {
    this.tiempoRestante = 60;
    this.puedeReenviar = false;
    
    // Limpiar cualquier intervalo anterior
    if (this.intervaloContador) {
      clearInterval(this.intervaloContador);
    }
    
    // Crear el intervalo
    this.intervaloContador = setInterval(() => {
      this.tiempoRestante--;
      
      if (this.tiempoRestante <= 0) {
        clearInterval(this.intervaloContador);
        this.puedeReenviar = true;
      }
    }, 1000); // Se ejecuta cada 1 segundo
  }

  ngOnDestroy() {
    if (this.intervaloContador) {
      clearInterval(this.intervaloContador);
    }
  }

  
  handleLogin(){
  
    
    if(this.usuario.correo==null || this.usuario.contrasena==null){
      //alert('Username o Password vacios');
      this.openMensaje('Username o Password vacios');
      return;
    }

    this.auth.logout();

    this.usuario.correo=this.usuario.correo.trim();
    
    this.auth.login(this.usuario).subscribe({next:response => {

       this.auth.guardarUsuario(response.access_token);
       this.auth.guardarToken(response.access_token);

       let usuario = this.auth.usuario;

       // Redirigir al home solo si estamos en el path /login
       if (window.location.pathname === '/login') {
         window.location.href = '/home';
       }

  },
  error:error => {
    if(error.status == 400){
      //alert('Usuario o clave incorrectos');
      this.openMensaje('Usuario o clave incorrectos');
    }
    this.usuario = new Usuario();
    this.invalidLogin =true;
  }}
  );


  }
  olvidoContrasenia(){
    const dialogRef = this.dialog.open(OlvidoComponent, {
      width: '600px'      
    });

    dialogRef.afterClosed().subscribe(result => {
      
      
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(RegistrarseComponent, {
      width: '600px',
      height:'750px'
      
    });

    dialogRef.afterClosed().subscribe(result => {
      
      
    });
  }

  openMensaje(mensajeT:string,openD?:string):void{
    let screenWidth = screen.width;
    let anchoDialog:string = '500px';
    let anchomax:string = '80vw';
    let altoDialog:string = '250';
    if(screenWidth<=600){
      anchoDialog = '100%';
      anchomax = '100%';
      altoDialog = 'auto';
    }
    const dialogRef = this.dialog.open(MensajeComponent, {
      width: anchoDialog,
      maxWidth: anchomax,
      height: altoDialog,
      data:{
        mensaje:mensajeT
      }
    });
  }

  loginWithGoogle(): void {
    this.cargando = true;
    this.auth.loginWithGoogle();
  }

  onInputChange(event: any, num: number): void {
    const input = event.target;
    let valor = input.value.toUpperCase();
    
    // Limitar a 1 carácter y convertir a mayúsculas
    if (valor.length > 1) {
        valor = valor.charAt(0);
    }
    
    this['digito' + num] = valor;
    input.value = valor;
    
    // Mover al siguiente input si hay un valor y no es el último
    if (valor.length === 1 && num < 4) {
        const nextInput = document.getElementById('input' + (num + 1)) as HTMLInputElement;
        if (nextInput) {
            nextInput.focus();
        }
    }
  }

  onKeyDown(event: KeyboardEvent, num: number): void {
      const input = event.target as HTMLInputElement;
      
      // Permitir retroceso para volver al input anterior
      if (event.key === 'Backspace' && input.value === '' && num > 1) {
          const prevInput = document.getElementById('input' + (num - 1)) as HTMLInputElement;
          if (prevInput) {
              prevInput.focus();
          }
      }
  }

  manejarPegado(event: ClipboardEvent): void {
      event.preventDefault();
      const pastedText = event.clipboardData?.getData('text').toUpperCase() || '';
      
      // Distribuir los caracteres en los inputs
      for (let i = 0; i < Math.min(pastedText.length, 4); i++) {
          this['digito' + (i + 1)] = pastedText.charAt(i);
      }
      
      // Enfocar el último input con valor o el siguiente vacío
      const lastIndex = Math.min(pastedText.length, 4);
      const lastInput = document.getElementById('input' + lastIndex) as HTMLInputElement;
      if (lastInput) {
          lastInput.focus();
      }
  }

  cambiarInicio() {
    this.correoPass = !this.correoPass;
  }
// Los métodos de Google OAuth fueron movidos al GoogleOAuthHandlerService
  // para manejo global desde cualquier componente
  
}
